import { SxProps, Theme } from "@mui/material";

const colors = {
    primary: {
        main: "#08519c",
    },
    background: {
        page: "#f5f7fa",
        card: "#ffffff",
    },
    text: {
        muted: "#718096",
    },
};

export const pillToggleGroupStyles: SxProps<Theme> = {
    bgcolor: colors.background.page,
    borderRadius: "50px",
    padding: "4px",
    width: "100%",
    "& .MuiToggleButton-root": {
        borderRadius: "50px",
        textTransform: "none",
        fontWeight: 500,
        border: "none",
        color: colors.text.muted,
        flex: 1,
        transition: "all 0.2s ease",
        "&.Mui-selected": {
            bgcolor: colors.background.card,
            color: colors.primary.main,
            boxShadow: `
        0 3px 8px rgba(8, 81, 156, 0.3),
        0 0 8px rgba(8, 81, 156, 0.3),
        0 0 16px rgba(8, 81, 156, 0.2)
    `,
            "&:hover": { bgcolor: colors.background.card },
        },
        "&:hover": {
            bgcolor: "transparent",
            color: colors.primary.main,
        },
    },
};